import { create } from 'zustand';
import type { AdminStats } from '@spawnwire/shared';
import { http } from '../../lib/api';

/** Dashboard numbers, also used for the sidebar's open-reports and open-appeals badges. */
export const useAdminStats = create<{ stats: AdminStats | null }>(() => ({ stats: null }));

export async function loadAdminStats(): Promise<void> {
  try {
    useAdminStats.setState({ stats: await http.get<AdminStats>('/admin/stats') });
  } catch {
    /* the dashboard shows its own error; badges just stay as they were */
  }
}
